import { useState } from 'react';

import dynamic from 'next/dynamic';

import Button from 'components/Button';

const ModalForm = dynamic(
  () => import('bx-forms/eas/getapp').then((mod) => mod.ModalForm),
  { ssr: false }
);
import { useEventContext } from 'context/EventContext';

import classes from './CtaGetList.module.scss';

const GATEWAY_URL = 'https://www.capterra.com/bx-capterra-api/bx-forms/submit';

/** @type {import("./types").default} */
const CtaGetList = ({}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { addEvent } = useEventContext({});

  return (
    <>
      <Button
        className={classes.root}
        variant="outlined"
        onClick={() => setIsOpen(true)}
        {...addEvent({
          engagementComponent: 'best-products_list',
          engagementDetails: 'button_get_list',
          engagementDestination: 'open_send-me-the-list-form',
          name: 'engagement_product_click',
        })}
        text="Get list"
        icon={['far', 'envelope']}
      />
      <ModalForm
        formId="7xu3cNnJ3tcSBy6DlnwEbG"
        gatewayUrl={GATEWAY_URL}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        isTimeline={true}
        headline="Send me a copy of this list to my Inbox"
        subHeading="Get a copy of this list with pricing info sent to your inbox."
        buttonText="Send me a copy"
        secondButtonText="SUBMIT"
        successHeadline="Thank you, enjoy!"
        successMessage="Your list will be delivered to your inbox shortly."
        contextProps={{ pageType: 'directory', pagePlacement: 'modal' }}
        tracking={{
          formName: 'DMBUY_2022_GA_Blog_Acq',
          contentCategory: 'Directory_Desktop_Exit Intent_CR',
          contentRequest: 'Product List_CR',
        }}
      />
    </>
  );
};

export default CtaGetList;
